import { __exports as asLowAsPricePerPiece } from './_virtual-asLowAsPricePerPiece2.js';
import { __require as requireEs_string_replace } from './node_modules-core-js-modules-es.string.replace.js';
import { __require as requireContainer } from './vp-js-token-engine-build-infrastructure-container.js';
import { __require as requireComparativePriceFilter } from './vp-js-token-engine-build-common-filters-comparativePriceFilter.js';
import { __require as requireLocalizations } from './vp-js-token-engine-build-infrastructure-localizations.js';

var hasRequiredAsLowAsPricePerPiece;

function requireAsLowAsPricePerPiece () {
	if (hasRequiredAsLowAsPricePerPiece) return asLowAsPricePerPiece;
	hasRequiredAsLowAsPricePerPiece = 1;

	Object.defineProperty(asLowAsPricePerPiece, "__esModule", {
	  value: true
	});
	asLowAsPricePerPiece.filter = filter;
	asLowAsPricePerPiece.name = void 0;
	requireEs_string_replace();
	var _container = requireContainer();
	var _comparativePriceFilter = requireComparativePriceFilter();
	var _localizations = requireLocalizations();
	const name = asLowAsPricePerPiece.name = 'asLowAsPricePerPiece';
	async function filter(listPrice, discountPrice, currency, minimumFractionDigits, vatInc, hideVatMessage, hideShippingMessageInVatMessage) {
	  const scope = this;
	  const culture = _container.contextService.getCulture(scope);
	  const {
	    htmlTemplates,
	    mustacheVariables
	  } = await (0, _comparativePriceFilter.comparativePriceFilter)(culture, listPrice, discountPrice, currency, minimumFractionDigits, vatInc, hideVatMessage, hideShippingMessageInVatMessage, scope);
	  const template = (0, _localizations.localized)(name, culture);
	  return _container.mustacheService.replace(template, mustacheVariables, htmlTemplates);
	}
	
	return asLowAsPricePerPiece;
}

export { requireAsLowAsPricePerPiece as __require };
//# sourceMappingURL=vp-js-token-engine-build-filters-asLowAsPricePerPiece.js.map
